<template>
  <div
  id="entryPage"
    class="auth-page-wrapper min-vh-100"
    style="background: #121831; color: #fff; overflow: hidden"
  >
    <div class="star-animation">
      <section>
        <div
          style="width: 100%; height: 100%; z-index: 999"
          class="position-relative"
        >
         <div class="w-100 d-flex justify-content-end">
            <i
              :class="[icon, 'me-3']"
              id="fullscreen"
              :style="{
                color: '#ffffff',
                cursor: 'pointer',
                fontSize: '32px',
              }"
              @click="toggleFullScreen()"
            ></i>
          </div>
          <img
            class="position-absolute w-50"
            style="top: 1rem; left: 25%; height: 3.5rem"
            src="@/assets/images/entryPage/1.svg"
            alt=""
          />
          <img
            class="position-absolute w-50"
            style="top: 6rem; left: 25%; height: 3.2rem"
            src="@/assets/images/entryPage/2.svg"
            alt=""
          />
          <div class="w-100 position-relative" style="margin-top: 7%;zoom:0.95">
            <img
              class="position-absolute circle"
              :class="[showTime >= 5 && 'circleShow']"
              style="
                width: 54rem;
                height: 54rem;
                left: 50%;
                margin-left: -27rem;
                margin-top: 0rem;
              "
              src="@/assets/images/entryPage/3.svg"
              alt=""
            />
            <img
              class="position-absolute circle"
              :class="[showTime > 4 && 'circleShow']"
              style="
                width: 44rem;
                height: 44rem;
                left: 50%;
                margin-left: -22rem;
                margin-top: 5rem;
              "
              src="@/assets/images/entryPage/3.svg"
              alt=""
            />
            <img
              class="position-absolute circle"
              :class="[showTime > 3 && 'circleShow']"
              style="
                width: 34rem;
                height: 34rem;
                left: 50%;
                margin-left: -17rem;
                margin-top: 10rem;
              "
              src="@/assets/images/entryPage/3.svg"
              alt=""
            />
            <img
              class="position-absolute circle"
              :class="[showTime > 2 && 'circleShow']"
              style="
                width: 24rem;
                height: 24rem;
                left: 50%;
                margin-left: -12rem;
                margin-top: 15rem;
              "
              src="@/assets/images/entryPage/3.svg"
              alt=""
            />
            <img
              class="position-absolute circle"
              :class="[showTime >= 1 && 'circleShow']"
              style="
                width: 14rem;
                height: 14rem;
                left: 50%;
                margin-left: -7rem;
                margin-top: 20rem;
              "
              src="@/assets/images/entryPage/3.svg"
              alt=""
            />

            <img
              class="position-absolute"
              style="
                width: 10.625rem;
                height: 3.125rem;
                left: 50%;
                margin-left: -5rem;
                margin-top: 35rem;
                zoom: 0.8;
              "
              src="@/assets/images/entryPage/iiot.svg"
              alt=""
            />
            <img
              class="position-absolute"
              style="
                width: 12.5rem;
                height: 3.125rem;
                left: 50%;
                margin-left: -6rem;
                margin-top: 30rem;
                zoom: 0.8;
              "
              src="@/assets/images/entryPage/Rectangle.svg"
              alt=""
            />
            <div
              class="box position-relative position-absolute"
              :class="[
                active == '1' && 'box_hover',
                'circle',
                showTime >= 6 && 'circleShow',
              ]"
              style="
                width: 54rem;
                height: 54rem;
                left: 50%;
                margin-left: -27rem;
                margin-top: 0rem;
                border: 0.125rem solid #9d9fa300;
                border-radius: 50%;
              "
            >
              <div
                class="position-absolute box-1 box-r"
                style="cursor: pointer; top: 51rem; left: 25rem"
                :class="[
                  active == '1' && 'box_hover',
                  'circle',
                  showTime >= 6 && 'circleShow',
                ]"
                @mouseover="boxChange('1')"
                @mouseout="boxChange('0')"
                @click="skipPage('dashboard')"
              >
                <img
                  style="width: 6.25rem; height: 6.25rem"
                  src="@/assets/images/entryPage/icon4.svg"
                  alt=""
                />
                <div
                  v-show="active == '1'"
                  style="font-size: 36px; font-weight: bold; text-align: center"
                >
                  主页
                </div>
              </div>
            </div>
            <div
              class="box_2 position-relative position-absolute"
              :class="[
                active == '2' && 'box_hover',
                'circle',
                showTime >= 6 && 'circleShow',
              ]"
              style="
                width: 44rem;
                height: 44rem;
                left: 50%;
                margin-left: -22rem;
                margin-top: 5rem;
                border: 0.125rem solid #9d9fa300;
                border-radius: 50%;
              "
            >
              <div
                class="position-absolute box-1 box_2s"
                style="cursor: pointer; top: 19rem; left: 41rem"
                :class="[
                  active == '2' && 'box_hover',
                  'circle',
                  showTime >= 6 && 'circleShow',
                ]"
                @mouseover="boxChange('2')"
                @mouseout="boxChange('0')"
                @click="skipPage('equipment-statistics')"

              >
                <img
                  style="width: 6.25rem; height: 6.25rem"
                  src="@/assets/images/entryPage/icon5.svg"
                  alt=""
                />
                <div
                  v-show="active == '2'"
                  style="font-size: 36px; font-weight: bold; text-align: center"
                >
                  {{$t('overview_static.device')}}
                </div>
              </div>
            </div>
            <div
              class="box_3 position-relative position-absolute"
              :class="[
                active == '3' && 'box_hover',
                'circle',
                showTime >= 6 && 'circleShow',
              ]"
              style="
                width: 34rem;
                height: 34rem;
                left: 50%;
                margin-left: -17rem;
                margin-top: 10rem;
                border: 0.125rem solid #9d9fa300;
                border-radius: 50%;
              "
            >
              <div
                class="position-absolute box-1 box_3s"
                style="cursor: pointer; top: -3rem; left: 14rem"
                :class="[
                  active == '3' && 'box_hover',
                  'circle',
                  showTime >= 6 && 'circleShow',
                ]"
                @mouseover="boxChange('3')"
                @mouseout="boxChange('0')"
                @click="skipPage('work-order-dashboard')"

              >
                <img
                  style="width: 6.25rem; height: 6.25rem"
                  src="@/assets/images/entryPage/icon1.svg"
                  alt=""
                />
                <div
                  v-show="active == '3'"
                  style="font-size: 36px; font-weight: bold; text-align: center"
                >
                  {{$t('overview_static.work_order')}}
                </div>
              </div>
            </div>
            <div
              class="box_4 position-relative position-absolute"
              :class="[
                active == '4' && 'box_hover',
                'circle',
                showTime >= 6 && 'circleShow',
              ]"
              style="
                width: 24rem;
                height: 24rem;
                left: 50%;
                margin-left: -12rem;
                margin-top: 15rem;
                border: 0.125rem solid #9d9fa300;
                border-radius: 50%;
              "
            >
              <div
                class="position-absolute box-1 box_4s"
                style="cursor: pointer; top: 9rem; left: -3rem"
                :class="[
                  active == '4' && 'box_hover',
                  'circle',
                  showTime >= 6 && 'circleShow',
                ]"
                @mouseover="boxChange('4')"
                @mouseout="boxChange('0')"
                @click="skipPage('business-opportunity-dashboard')"

              >
                <img
                  style="width: 6.25rem; height: 6.25rem"
                  src="@/assets/images/entryPage/icon2.svg"
                  alt=""
                />
                <div
                  v-show="active == '4'"
                  style="font-size: 36px; font-weight: bold; text-align: center"
                >
                  {{$t('overview_static.business_opportunity')}}
                </div>
              </div>
            </div>
            <div
              class="box_5 position-relative position-absolute"
              :class="[
                active == '5' && 'box_hover',
                'circle',
                showTime >= 6 && 'circleShow',
              ]"
              style="
                width: 14rem;
                height: 14rem;
                left: 50%;
                margin-left: -7rem;
                margin-top: 20rem;
                border: 0.125rem solid #9d9fa300;
                border-radius: 50%;
              "
            >
              <div
                class="position-absolute box-1 box_5s"
                style="cursor: pointer; top: 0; left: -2rem"
                :class="[
                  active == '5' && 'box_hover',
                  'circle',
                  showTime >= 6 && 'circleShow',
                ]"
                @mouseover="boxChange('5')"
                @mouseout="boxChange('0')"
                @click="skipPage('dashboard')"
              >
                <img
                  style="width: 6.25rem; height: 6.25rem"
                  src="@/assets/images/entryPage/icon3.svg"
                  alt=""
                />
                <div
                  v-show="active == '5'"
                  style="font-size: 36px; font-weight: bold; text-align: center"
                >
                  {{$t('overview_static.dashboard')}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </section>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      active: 0,
      show: true,
      showTime: 0,
      fullscreen: false,
    };
  },
  mounted() {
        let that = this;
    window.addEventListener("resize", () => {
      if (!that.isFullScreen()) {
        // 非全屏状态
        //业务逻辑
        this.fullscreen = false;
      }
    });
    for (let index = 0; index < 6; index++) {
      setTimeout(() => {
        this.showTime = this.showTime + 1;
        console.log(this.showTime);
      }, 200 + 200 * (index + 1));
    }
    this.startFactory(document.getElementsByClassName("star-animation")[0]);
  },
   computed: {
    icon() {
      return this.fullscreen ? "ri-fullscreen-exit-line" : "ri-fullscreen-line";
    },
  },
  methods: {
         skipPage(path) {
      this.$router.push("/" + path);
    },
       //全屏
    fullele() {
      return (
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement ||
        document.mozFullScreenElement ||
        null
      );
    },

    //判断是否全屏
    isFullScreen() {
      return !!(document.webkitIsFullScreen || this.fullele());
    },
    //退出全屏
    exitFullscreen() {
      this.fullscreen = false;

      if (document.exitFullScreen) {
        document.exitFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    },
    //全屏
    full(ele) {
      if (ele.requestFullscreen) {
        ele.requestFullscreen();
      } else if (ele.mozRequestFullScreen) {
        ele.mozRequestFullScreen();
      } else if (ele.webkitRequestFullscreen) {
        ele.webkitRequestFullscreen();
      } else if (ele.msRequestFullscreen) {
        ele.msRequestFullscreen();
      }
    },
    //切换是否全屏 全屏按钮要执行的方法
    toggleFullScreen() {
      if (this.isFullScreen()) {
        this.exitFullscreen();
      } else {
        this.fullscreen = true;
        this.full(document.getElementById("entryPage")); //要设置全屏的元素
      }
    },
    boxChange(num) {
      this.active = num;
      console.log(num);
    },
    startFactory(container) {
      // window.innerWidth 控制星星的密度
      for (var i = 0; i < window.innerWidth / 10; i++) {
        container.append(this.starFactory());
      }
    },
    starFactory() {
      let star = document.createElement("div");
      let width = Math.ceil(Math.random() * 4);
      star.style.position = "absolute";
      star.style.width = width + "px";
      star.style.height = width + "px";
      star.style.opacity = "0.9";
      star.style.backgroundColor = "#FFFFFF";
      star.style.top = Math.ceil(Math.random() * window.innerHeight) + "px";
      star.style.left = Math.ceil(Math.random() * window.innerWidth) + "px";
      star.style.boxShadow = "#121831 0 0 " + 1 + "px " + 1 + "px";
      star.style.borderRadius = width + "px";

      // 当星星直径小于3时，有一个放大缩小的动画
      if (width < 4) {
        star.style.boxShadow =
          "0 0 0 4px rgba(255,255,255,0.1),0 0 0 .5rem rgba(255,255,255,0.1),0 0 1.25rem rgba(255,255,255,1)" +
          width / 2 +
          "px " +
          width / 2 +
          "px";
        star.style.animation = "identifier 2000ms infinite 500ms";
      }
      return star;
    },
  },
};
</script>

<style scoped lang='scss'>
@import "@/assets/scss/entry.scss";

@media only screen and (max-width: 1920px) {
  body {
    zoom: 0.9;
  }
}
.circle {
  opacity: 0;
}
.circleShow {
  opacity: 1;
  transition: all 1s;
}
</style>
